export default "__VITE_ASSET__B$MkYCLL__"